import React, { memo } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Drawer as ChakraDrawer,
  DrawerContent,
  DrawerCloseButton,
  DrawerFooter,
  DrawerOverlay,
  DrawerHeader,
  DrawerBody,
} from "@chakra-ui/react";

const Drawer = ({
  isOpen,
  onClose,
  placement,
  children,
  headerText,
  cancelText,
}) => (
  <ChakraDrawer isOpen={isOpen} placement={placement} onClose={onClose}>
    <DrawerOverlay />
    <DrawerContent>
      <DrawerCloseButton size="lg" />
      {headerText && <DrawerHeader>{headerText}</DrawerHeader>}
      <DrawerBody>{children}</DrawerBody>
      {cancelText && (
        <DrawerFooter>
          <Button mr={3} onClick={onClose}>
            {cancelText}
          </Button>
        </DrawerFooter>
      )}
    </DrawerContent>
  </ChakraDrawer>
);

Drawer.propTypes = {
  cancelText: PropTypes.string,
  children: PropTypes.node.isRequired,
  headerText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  placement: PropTypes.string,
};

Drawer.defaultProps = {
  cancelText: undefined,
  headerText: undefined,
  placement: "bottom",
};

export default memo(Drawer);
